export type DocumentNodeType = "folder" | "document";

export type DocumentNode = {
  Id: number;
  Name: string;
  HierarchyLevel: number;
  // document-only fields
  Description?: string | null;
  DocumentType?: string | null;
  URL?: string | null;
  Parent_Id?: number | null;
  OrderNumber?: number;
  // tree
  Children?: DocumentNode[];
  // local UI state (not sent to server)
  _expanded?: boolean;
};

export const DOCUMENT_TYPES = [
  { label: "PDF", value: "PDF" },
  { label: "Video", value: "VID" },
  { label: "URL", value: "URL" },
  { label: "ZIP", value: "ZIP" },
] as const;
